import React, { useEffect, useMemo, useState } from 'react';
import { TouchableOpacity } from 'react-native';
import { FontAwesome5 } from '@expo/vector-icons';

import { deletePreMessage, getPreMessageHistory, getPreMessagesData } from '../../../api/Marketing';
import { BasicLayout, CommonContainer } from '../../../common/components/CustomLayout';
import { BOHTBody, BOHTD, BOHTDIconBox, BOHTH2, BOHTHead, BOHTR, BOHTable } from '../../../common/components/bohtable';
import { BOHButton, BOHToolbar } from '../../../common/components/bohtoolbar';
import { msgStr } from '../../../common/constants/Message';
import { TextMediumSize } from '../../../common/constants/Fonts';
import { useAlertModal, useConfirmModal } from '../../../common/hooks';

import AddPreMessageModal from './AddPreMessageModal';
import { getBrandsData } from '../../../api/Price';
import MessageHistoryModal from './MessageHistoryModal';

const PreMessages = ({ navigation }) => {
  const { showAlert } = useAlertModal();
  const { showConfirm } = useConfirmModal();
  
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [updatePreMessageTrigger, setUpdatePreMessagesTrigger] = useState(true);
  const InitialWidths = [120, 120, 130, 110, 200, 700, 80, 80];

  const [isAddModalVisible, setAddModalVisible] = useState(false);
  const [ishistoryModalVisible, sethistoryModalVisible] = useState(false);
  const [selectedPreMessage, setSelectedPreMessage] = useState(null);
  const [brands, setBrands] = useState([]);
  const [history, setHistory] = useState([]);

  const openAddPreMessageModal = () => {
    setAddModalVisible(true);
    setSelectedPreMessage(null);
  };
  const closeAddPreMessageModal = () => {
    setAddModalVisible(false);
    setSelectedPreMessage(null);
  };
  const openHistoryModal = () => {
    sethistoryModalVisible(true);
  };
  const closeHistoryModal = () => {
    sethistoryModalVisible(false);
    setHistory([]);
  };
  const editPreMessage = (item) => {
    setSelectedPreMessage(item);
    setAddModalVisible(true);
  };
  const showHistory = (item) => {
    getPreMessageHistory({id:item.id}, (jsonRes)=>{
      setHistory(jsonRes)
      openHistoryModal()
    })
  }

  useEffect(() => {
    getBrandsData((jsonRes) => {
      setBrands(
        jsonRes.map(item => ({
          id: item.id,
          name: item.brand  
        }))
      );
      setUpdatePreMessagesTrigger(true);
    });
  }, []);
  
  useEffect(() => {
    if (updatePreMessageTrigger == true) getTable();
  }, [updatePreMessageTrigger]);

  const removePreMessage = (id) => {
    showConfirm(msgStr('deleteConfirmStr'), () => {
      deletePreMessage(id, (jsonRes, status, error) => {
        switch (status) {
          case 200:
            setUpdatePreMessagesTrigger(true);
            showAlert('success', jsonRes.message);
            break;
          default:
            if (jsonRes && jsonRes.error) showAlert('error', jsonRes.error);
            else showAlert('error', msgStr('unknownError'));
            break;
        }
      });
    });
  };

  const getTable = () => {
    setIsLoading(true);
    getPreMessagesData((jsonRes, status, error) => {
      switch (status) {
        case 200:
          setUpdatePreMessagesTrigger(false);
          setTableData(jsonRes);
          break;
        case 500:
          showAlert('error', msgStr('serverError'));
          break;
        default:
          if (jsonRes && jsonRes.error) showAlert('error', jsonRes.error);
          else showAlert('error', msgStr('unknownError'));
          break;
      }
    });
  };

  const renderTableData = useMemo(() => {
    const rows = [];
    if (tableData.length > 0) {
      tableData.map((item, index) => {
        rows.push(
          <BOHTR key={index}>
            <BOHTD width={InitialWidths[0]} textAlign='right'>{item.before}</BOHTD>
            <BOHTD width={InitialWidths[1]} textAlign='right'>{item.after}</BOHTD>
            <BOHTD width={InitialWidths[2]} textAlign='right'>{item.before_pickup}</BOHTD>
            <BOHTD width={InitialWidths[3]}>{item.time}</BOHTD>
            <BOHTD width={InitialWidths[4]}>
            {Array.isArray(item.brand_ids) 
              ? brands
                  .filter((brand: any) => item.brand_ids.includes(brand.id))
                  .map((brand: any) => brand.name)
                  .join('\n')
              : 'No brands available'}
            </BOHTD>
            <BOHTD width={InitialWidths[5]}>{item.template}</BOHTD>
            <BOHTDIconBox width={InitialWidths[6]}>
              <TouchableOpacity
                onPress={() => {
                  showHistory(item);
                }}
              >
                <FontAwesome5 size={TextMediumSize} name="eye" color="black" />
              </TouchableOpacity>
            </BOHTDIconBox>
            <BOHTDIconBox width={InitialWidths[7]}>
              <TouchableOpacity
                onPress={() => {
                  editPreMessage(item);
                }}
              >
                <FontAwesome5 size={TextMediumSize} name="edit" color="black" />
              </TouchableOpacity>
            </BOHTDIconBox>
            <BOHTDIconBox width={InitialWidths[7]}>
              <TouchableOpacity
                onPress={() => {
                  removePreMessage(item.id);
                }}
              >
                <FontAwesome5 size={TextMediumSize} name="times" color="black" />
              </TouchableOpacity>
            </BOHTDIconBox>
          </BOHTR>
        );
      });
    } else {
      <></>;
    }
    
    setIsLoading(false);
    return <>{rows}</>;
  }, [tableData]);

  const tableElement = useMemo(()=>(        
    <BOHTable isLoading={isLoading}>
      <BOHTHead>
        <BOHTR>
          <BOHTH2 width={InitialWidths[0]}>{'Before(days)'}</BOHTH2>
          <BOHTH2 width={InitialWidths[1]}>{'After(days)'}</BOHTH2>
          <BOHTH2 width={InitialWidths[2]}>{'Before_pickup'}</BOHTH2>
          <BOHTH2 width={InitialWidths[3]}>{'time'}</BOHTH2>
          <BOHTH2 width={InitialWidths[4]}>{'Brands'}</BOHTH2>
          <BOHTH2 width={InitialWidths[5]}>{'template'}</BOHTH2>
          <BOHTH2 width={InitialWidths[6]}>{'History'}</BOHTH2>
          <BOHTH2 width={InitialWidths[7]}>{'Edit'}</BOHTH2>
          <BOHTH2 width={InitialWidths[7]}>{'DEL'}</BOHTH2>
        </BOHTR>
      </BOHTHead>
      <BOHTBody>
        {renderTableData}
      </BOHTBody>
    </BOHTable>), [isLoading, tableData])

  return (
    <BasicLayout
      navigation={navigation}
      goBack={() => {
        navigation.navigate('Marketing');
      }}
      screenName={'PreMessage Manager'}
    >
      <CommonContainer>
        <BOHToolbar>
          <BOHButton
            label="Add"
            onPress={openAddPreMessageModal}/>
        </BOHToolbar>
        {tableElement}
      </CommonContainer>
      <AddPreMessageModal
        isModalVisible={isAddModalVisible}
        details={selectedPreMessage}
        setUpdatePreMessagesTrigger={setUpdatePreMessagesTrigger}
        closeModal={closeAddPreMessageModal}
      />
      <MessageHistoryModal
        isModalVisible={ishistoryModalVisible}
        history={history}
        closeModal={closeHistoryModal}
      />
    </BasicLayout>
  );
};

export default PreMessages;
